import { useQuery } from '@tanstack/react-query';
import { fetchServiceAgreementService } from 'stores/queries/service-agreement-services/service-agreement-service-queries';

export const useFetchServiceAgreementService = ({ serviceAgreementServiceId }: { serviceAgreementServiceId: string }) =>
  useQuery({
    queryFn: async () => (await fetchServiceAgreementService({ serviceAgreementServiceId })).data,
    queryKey: ['service-agreement-service-id', serviceAgreementServiceId],
  });
